<template>
  <div>
    <v-dialog
      content-class="ad-hoc-promo-codes-details-dialog"
      v-model="showDetails"
      persistent
      max-width="320px">
      <div class="ad-hoc-promo-codes-details-dialog-content">
        <h3>{{ promoName }}</h3>
        <div class="promo-description">{{ promoDescription }}</div>
        <v-btn @click="closeDetails" class="details-close-button">{{ $t('Account.AdHocPromoCodes.Close') }}</v-btn>
      </div>
    </v-dialog>
    <loader v-if="showLoader"></loader>
    <div class="ad-hoc-promo-codes-container" v-if="isInitDone">
      <div class="success-message-panel" v-if="showSuccess">
        <div class="success-icon"></div>
        <div>{{ sucessMessage }}</div>
        <div class="details-part" @click="openDetails">
          <div class="details-label">{{ $t('Account.AdHocPromoCodes.Details') }}</div>
          <div class="details-icon"></div>
        </div>
      </div>
      <div v-if="hasAdHocPromoCodes" class="promotion-panel">
        <div class="promotion-header">
          {{ $t('Account.AdHocPromoCodes.PanelTitle') }}
        </div>
        <div class="content">
          <div>
            {{ $t('Account.AdHocPromoCodes.EnterCode') }}
          </div>
          <div class="input-area">
            <input type="textbox" class="code-input" v-model="promoCode">
            <button :disabled="promoCode.trim().length === 0" class="v-btn theme--light claim-button" :class="{'v-btn--disabled': isClaimDisabled}" @click="claimPromoCode">{{ $t('Account.AdHocPromoCodes.Claim') }}</button>
          </div>
          <div class="promo-code-error" v-if="hasError">
            {{ errorMessage }}
          </div>
        </div>
      </div>
      <div v-else class="no-code">
        {{ noCodeHint }}
      </div>
    </div>
  </div>
</template>

<script>
import lib from '@/library'
import Loader from '@/components/common/Loader.vue'

const AD_HOC_PROMO_TYPE = 'ADHOCPROMOCODE'

export default {
  components: {
    Loader
  },
  name: 'AdHocPromoCodes',
  data () {
    return {
      showLoader: false,
      isInitDone: false,
      showDetails: false,
      showSuccess: false,
      promoCode: '',
      hasAdHocPromoCodes: false,
      promoName: '',
      promoDescription: '',
      errorMessage: ''
    }
  },
  computed: {
    sucessMessage () {
      const msg = this.$t('Account.AdHocPromoCodes.AssignedSuccessfully').replace('{CODE}', this.promoName)
      return msg
    },
    hasError () {
      return this.errorMessage.trim() !== ''
    },
    isClaimDisabled () {
      const isDisabled = !this.promoCode || this.promoCode.trim().length === 0
      return isDisabled
    },
    noCodeHint () {
      const myHint = this.showSuccess ? this.$t('Account.AdHocPromoCodes.NoMoreCode') : this.$t('Account.AdHocPromoCodes.NoCode')
      return myHint
    }
  },
  methods: {
    checkHasAdHocPromoCodes () {
      this.showLoader = true

      const param = { promoType: AD_HOC_PROMO_TYPE }
      lib.rpcService.callBroker('iw', 'checkpromoavailabilitybytype', param)
        .then(response => {
          console.log('response', response)
          if (response && response.result && response.result.toString().toUpperCase() === 'TRUE') {
            this.hasAdHocPromoCodes = true
          } else {
            this.hasAdHocPromoCodes = false
          }
        }).catch((error) => {
          this.hasAdHocPromoCodes = false
          console.log(error)
        }).finally(() => {
          this.showLoader = false
          this.isInitDone = true
        })
    },
    claimPromoCode () {
      this.showSuccess = false
      this.promoName = ''
      this.promoDescription = ''
      this.showLoader = true
      this.errorMessage = ''

      const request = {
        promocode: this.promoCode,
        promotype: AD_HOC_PROMO_TYPE
      }

      lib.rpcService.callBroker('iw', 'setpromocode4customerextended', request)
        .then(response => {
          console.log('response', response)
          if (response && response.exceptionType && response.message) {
            this.errorMessage = response.message
          } else if (response && response.result && response.result.description) {
            this.showSuccess = true
            this.promoCode = ''
            this.promoName = response.result.description
            this.promoDescription = response.result.note
            this.hasAdHocPromoCodes = response.result.hasmore.toString().toUpperCase() === 'TRUE'
          } else {
            this.errorMessage = this.$t('Server.ErrorMsg.Generic')
          }
        }).catch((error) => {
          console.log(error)
          this.errorMessage = error.message || this.$t('Server.ErrorMsg.Generic')
        }).finally(() => {
          // Convert the invalid code error message to be more specific
          if (this.errorMessage && this.errorMessage.toLocaleLowerCase().indexOf('invalid') > -1) {
            this.errorMessage = this.$t('Account.AdHocPromoCodes.InvalidCode').replace(/{CODE}/, this.promoCode)
          }

          this.showLoader = false
        })
    },
    openDetails () {
      this.showDetails = true
    },
    closeDetails () {
      this.showDetails = false
    }
  },
  mounted () {
    this.checkHasAdHocPromoCodes()
  }
}
</script>

<style lang="stylus" scoped>
.ad-hoc-promo-codes-container
  display: flex
  flex-direction: column
  align-items: center
  padding: 0 5px
  width: 100%
  .no-code
    width: 100%
    padding: 5px
  .success-message-panel
    padding: 10px 10px 20px 10px
    color: var(--ad-hoc-promo-codes-success-color)
    display: flex
    flex-direction: column
    gap: 5px
    align-items: center
    .success-icon
      background-image: var(--ad-hoc-promo-codes-success-icon)
      height: 40px
      width: 40px
      background-size: 100%
    .details-part
      display: flex
      gap: 5px;
      align-items: center
      cursor: pointer
      .details-label
        color: var(--ad-hoc-promo-codes-details-color)
      .details-icon
        background-image: var(--ad-hoc-promo-codes-details-details-icon)
        height: 16px
        width: 8px
        background-size: 100%
  .promotion-panel
    display: flex
    flex-direction: column
    width: 100%
    border: 1px solid var(--ad-hoc-promo-codes-border-color)
    .promotion-header
      font-size: 16px
      font-family: 'Open Sans Bold'
      padding: 10px
      display: flex
      align-items: center
      background-color: var(--ad-hoc-promo-codes-header-background-color)
      color: var(--ad-hoc-promo-codes-header-color)
    .content
      display: flex
      flex-direction: column
      padding: 14px
      gap: 5px
      background-color: var(--ad-hoc-promo-codes-content-background-color)
      .input-area
        display: flex
        align-items: center
        .code-input
          border-radius 6px
          border: 0
          padding-left: 10px
          flex: 1
          height: 40px
          background-color: var(--ad-hoc-promo-codes-input-box-background-color)
          color: var(--ad-hoc-promo-codes-input-box-color)
          &:active,
          &:focus
            outline none
        .claim-button
          flex: 0
          width: 95px
          height: 40px
          font-family: 'Open Sans Bold'
          border-radius: 0
          color: var(--ad-hoc-promo-codes-button-color)
          background: var(--ad-hoc-promo-codes-button-background-color)
          &:disabled
            background-color: var(--ad-hoc-promo-codes-button-disalbed-background-color) !important
    .promo-code-error
      color: var(--ad-hoc-promo-codes-error-color)
.ad-hoc-promo-codes-details-dialog
  background-color: var(--ad-hoc-promo-codes-details-dialog-background-color) !important
  color: var(--ad-hoc-promo-codes-details-dialog-color) !important
  .ad-hoc-promo-codes-details-dialog-content
    background-color: var(--ad-hoc-promo-codes-details-dialog-background-color)
    display: flex
    flex-direction: column
    align-items: center
    color: var(--ad-hoc-promo-codes-details-dialog-color)
    .promo-description
      margin-bottom: 10px
    .details-close-button
      font-family: 'Open Sans Bold'
      background-color: var(--ad-hoc-promo-codes-details-dialog-background-color) !important
      border: 2px solid var(--ad-hoc-promo-codes-details-dialog-color)
      color: var(--ad-hoc-promo-codes-details-dialog-color)
</style>



// WEBPACK FOOTER //
// src/components/account/AdHocPromoCodes.vue